<template>
  <div class="tech-wrapper">
    <div
      class="tech"
      v-for="(item, index) in techs || []"
      :key="index"
      :data="item"
      @click="onClick(item)"
    >
      <div class="avatar" style="margin: 0">
        <span v-if="!item.photo_url">{{
          (item.name ? item.name : item.email) | getFirstLetter
        }}</span>
        <img v-else :src="item.photo_url" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["techs"],
  methods: {
    onClick: function (tech) {
      let routeUrl = this.$router.resolve({
        path: "/resume/" + tech.id + "/allinfo",
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style scoped>
.tech-wrapper {
  display: flex;
}
.tech {
  width: 32px;
  height: 32px;
  /* border: 1px solid #e8e8e8; */
  border-radius: 50%;
  cursor: pointer;
}
.tech > * {
  cursor: pointer;
  width: 32px;
  height: 32px;
}
</style>
